<section class="feed" [class.contraste]="this.contrasteAtivo" id="feed">
    <!-- <div class="circle" *ngFor="let item of [0,1,2,3,4,5,6,7,8,9,10]"></div> -->
    <div class="feed__inner">
        <!-- [swiper]="this.swiperConfig" #swiper -->
        <div class="blog-slider">
            <div class="blog-slider__wrp swiper-wrapper">
                <div class="blog-slider__item swiper-slide" *ngFor="let feed of this.feeds">
                    <div class="blog-slider__img">
                        <img src="{{ feed.Imagem }}" alt="">
                    </div>
                    <div class="blog-slider__content">
                        <span class="blog-slider__code"> {{ feed.Data}}</span>
                        <div class="blog-slider__title"> {{ feed.Titulo }}</div>
                        <div class="blog-slider__text"> {{ feed.Texto }} </div>
                        <button class="blog-slider__button">Leia Mais</button>
                    </div>
                </div>
            </div>
            <button type="button" class="swiper-button swiper-button-prev"><i class="fas fa-chevron-left"></i></button>
            <button type="button" class="swiper-button swiper-button-next"><i class="fas fa-chevron-right"></i></button>
            <div class="blog-slider__pagination"></div>
        </div>
    </div>

    <canvas id="c"></canvas>
    <div class="renderScript-slick-feed"></div>
</section>